// extracted by mini-css-extract-plugin
export default {"list":"styles_list__Jf+no","message":"styles_message__MBFUY"};